import { useTranslation } from 'react-i18next';

import { BILLING_METHODS, BillingMethodKey } from '@/constants/billingMethods';
import { BaseSelectOption } from '@/forms/types';

type BillingMethodOption = Exclude<BaseSelectOption, null>;

export const useBillingMethodOptions = (): BillingMethodOption[] => {
  const { t } = useTranslation('billingMethod');

  return (Object.keys(BILLING_METHODS) as BillingMethodKey[]).map((key) => ({
    id: String(BILLING_METHODS[key]),
    value: t(`${key}`),
  }));
};
